module.exports = __webpack_public_path__ + "img/man-mouth.a8d984ac.png";